import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isOpenSubject = new BehaviorSubject<boolean>(true);

  // Expose the observable part of the isOpen subject
  public isOpen$ = this.isOpenSubject.asObservable();

  constructor() {}

  // Method to toggle the sidebar
  toggle() {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  // Method to explicitly open or close the sidebar
  setSidebarOpenState(isOpen: boolean) {
    this.isOpenSubject.next(isOpen);
  }
}
